import { WEB_CONFIG } from './config';

/**
 * Masaüstü servisleri birkaç yerde `process` okuyor (`process.env.API_URL`,
 * `process.platform`). Tarayıcıda `process` yok; burada yalnızca o alanlar
 * tanımlanıyor. main.tsx'in ilk içe aktarması olmalı — servis modülleri
 * yüklenmeden önce çalışsın.
 *
 * DİKKAT: bu yalnızca geliştirme sunucusu için yedek. Yayın derlemesinde Vite
 * `process.env` ifadelerini derleme anında değiştiriyor; asıl değerler
 * vite.web.config.ts > `define` içinde veriliyor. İkisi aynı anahtarları taşımalı.
 *
 * `versions.node` kasıtlı olarak yok: supabase-js ve başka kütüphaneler Node
 * ortamını buna bakarak algılıyor.
 */
const env: Record<string, string> = {
  NODE_ENV: import.meta.env.MODE === 'production' ? 'production' : 'development',
  API_URL: WEB_CONFIG.apiUrl,
  DEEPGRAM_MODEL: WEB_CONFIG.deepgramModel,
  TALKNOTE_CLIENT_NAME: 'talknote-web',
};

const target = globalThis as unknown as { process?: { env: Record<string, string>; platform: string; arch: string } };
target.process ??= { env, platform: 'web', arch: 'browser' };
